"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapPageElement = void 0;
var wrapPageElement_1 = require("./src/wrapPageElement");
Object.defineProperty(exports, "wrapPageElement", { enumerable: true, get: function () { return wrapPageElement_1.wrapPageElement; } });
